@if (!!serverError()) {
  <div class="error" role="alert">
    <cue-icon [icon]="ICONS.cueExclamation" />
    {{ serverError() }}
    @if (exchangeErrorDetails(); as details) {
      <div class="error-details">
        <div>
          {{ translation.account.loginErrorCode | transloco }}: <code>{{ details.code }}</code>
        </div>
        @if (details.requestId) {
          <div>
            {{ translation.account.loginRequestId | transloco }}: <code>{{ details.requestId }}</code>
          </div>
        }
      </div>
    }
  </div>
}

@if (loginMode === 'gspace') {
  <button (click)="loginOAuth()" class="google login-w-icon">
    <img src="/assets/icons/google_logo.svg" />
    <p>{{ translation.login.loginWith | transloco }} Google</p>
  </button>
}
@if (loginMode === 'o365') {
  <button (click)="loginOAuth()" class="office365 login-w-icon">
    <img src="/assets/icons/microsoft_logo.svg" />
    <p>&nbsp;{{ translation.login.loginWith | transloco }} Microsoft 365</p>
  </button>
}

@if (loginMode === 'ews') {
  <div class="exchange login-options">
    <form [formGroup]="exchangeForm">
      <div class="form-group form-group--gap">
        <div>
          <assist-textbox
            data-cy="assist-login-exchange-username"
            [showClear]="true"
            class="form-control input-group"
            formControlName="username"
            id="username"
            name="username"
            placeholder="Username"
            type="text"
            [iconBefore]="ICONS.cueUser"
          />
        </div>
        <div>
          <assist-password
            data-cy="assist-login-exchange-password"
            [showVisibilityToggle]="true"
            class="form-control input-group password"
            formControlName="password"
            id="password"
            name="password"
            placeholder="Password"
            [iconBefore]="ICONS.cueLock"
          />
        </div>
      </div>
    </form>
    <div class="btn-wrapper">
      <button (click)="onLogin()" class="exchange btn continue-btn" data-cy="assist-login-exchange-button">
        {{ translation.login.loginWith | transloco }}&nbsp;EXCHANGE
        <cue-icon [icon]="ICONS.cueExchange" />
      </button>
    </div>
  </div>
}

@if (emailLinkLoginEnabled || passwordLoginEnabled || configService.value.externalLoginCAs.length > 0) {
  <div class="login-options">
    <form [formGroup]="loginForm" (ngSubmit)="onTouchoneSubmit()" class="">
      @if (emailLinkLoginEnabled || passwordLoginEnabled) {
        <div class="form-group">
          <label for="emailPhoenix">E-mail</label>
          <assist-textbox
            data-cy="assist-login-email-input"
            [showClear]="true"
            class="form-control input-group"
            formControlName="email"
            id="emailPhoenix"
            name="emailPhoenix"
            placeholder="name@domain.com"
            type="text"
            required="true"
            [iconBefore]="ICONS.cueUser"
          />
        </div>
      }

      @if (emailLinkLoginEnabled || passwordLoginEnabled) {
        @if (touchoneLoginStep() === 'email') {
          <div class="btn-wrapper">
            <button
              class="btn continue-btn"
              type="button"
              (click)="continueToPasswordStep()"
              [disabled]="loading()"
              data-cy="assist-login-email-button"
            >
              {{ translation.login.continue | transloco }}
              <cue-icon [icon]="ICONS.cueArrowFullRight" />
            </button>
          </div>
        }
        @if (passwordLoginEnabled && touchoneLoginStep() === 'password') {
          <div class="form-group">
            <label for="passwordPhoenix">{{ translation.login.password | transloco }}</label>
            <assist-password
              data-cy="assist-login-password-input"
              [showVisibilityToggle]="true"
              class="form-control input-group password"
              formControlName="password"
              id="passwordPhoenix"
              name="passwordPhoenix"
              [placeholder]="translation.login.password | transloco"
              [iconBefore]="ICONS.cueLock"
            />
            @if (passwordControl.touched && passwordControl.invalid) {
              <p class="validation-error">
                {{ translation.account.requiredField | transloco }}
              </p>
            }
          </div>
          <div class="btn-wrapper btn-wrapper--touchone-password">
            @if (emailLinkLoginEnabled) {
              <button
                class="btn secondary-btn"
                type="button"
                (click)="onLoginPhoenix()"
                [disabled]="loading()"
                data-cy="assist-login-email-link-button"
              >
                {{ translation.login.loginViaEmailLink | transloco }}
              </button>
            }
            <button
              class="btn continue-btn"
              type="submit"
              [disabled]="loading()"
              data-cy="assist-login-password-button"
            >
              {{ translation.login.loginViaPassword | transloco }}
              <cue-icon [icon]="ICONS.cueLogin" />
            </button>
          </div>
          <div class="forgot-password-link-wrapper">
            <a [routerLink]="['/account/reset-password']">{{ translation.login.forgotPassword | transloco }}</a>
          </div>
        }
      }

      @if ((emailLinkLoginEnabled || passwordLoginEnabled) && configService.value.externalLoginCAs.length > 0) {
        <div class="or-separator">{{ translation.login.or | transloco }}</div>
      }
      <div class="external-logins">
        @for (externalLoginCA of configService.value.externalLoginCAs; track externalLoginCA) {
          <button class="login-link" type="button" (click)="loginRedirect(externalLoginCA)">
            @switch (externalLoginCA.serverTypeId) {
              @case (1) {
                <img src="/assets/icons/microsoft_logo.svg" />
              }
              @case (4) {
                <img src="/assets/icons/google_logo.svg" />
              }
            }
            {{ externalLoginCA.externalLoginText }}
          </button>
        }
      </div>
    </form>
  </div>
}
